<i class="fas fa-award text-success {$$restProps.class ?? ''}"></i>
